"use client";

import { usePhoneField } from "../hooks/usePhoneField";

export default function PhoneField({ label = 'Phone', country = 'US', onChange }) {
  const {
    rawValue, setRawValue,
    confirmValue, setConfirmValue,
    countryPrefix,
    isValid, mismatch,
  } = usePhoneField('', country);

  const normalize = (prefix, v) => {
    if (!v) return '';
    const digits = String(v).replace(/[^\d]/g, '');
    return `${prefix}${digits}`;
  };

  const handleMain = (e) => {
    const v = e.target.value;
    setRawValue(v);
    if (typeof onChange === 'function') {
      const nextMain = normalize(countryPrefix, v);
      const nextConfirm = normalize(countryPrefix, confirmValue);
      onChange(nextMain, nextConfirm);
    }
  };

  const handleConfirm = (e) => {
    const v = e.target.value;
    setConfirmValue(v);
    if (typeof onChange === 'function') {
      const nextMain = normalize(countryPrefix, rawValue);
      const nextConfirm = normalize(countryPrefix, v);
      onChange(nextMain, nextConfirm);
    }
  };

  return (
    <div className="space-y-2">
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-1">{label}</label>
        <div className="flex">
          <span className="px-3 inline-flex items-center bg-gray-800 border border-r-0 border-gray-700 text-sm rounded-l-md text-textSecondary">
            {countryPrefix}
          </span>
          <input
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            value={rawValue}
            onChange={handleMain}
            placeholder="Enter number"
            className="flex-1 px-3 py-2 bg-gray-800 border border-gray-600 rounded-r-md shadow-sm focus:outline-none"
          />
        </div>
        {!isValid && rawValue && (
          <p className="text-yellow-400 text-sm mt-1">⚠️ This number may be invalid.</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-300 mb-1">Confirm {label}</label>
        <div className="flex">
          <span className="px-3 inline-flex items-center bg-gray-800 border border-r-0 border-gray-700 text-sm rounded-l-md text-textSecondary">
            {countryPrefix}
          </span>
          <input
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            value={confirmValue}
            onChange={handleConfirm}
            placeholder="Re-enter number"
            className="flex-1 px-3 py-2 bg-gray-800 border border-gray-600 rounded-r-md shadow-sm focus:outline-none"
          />
        </div>
        {mismatch && <p className="text-red-400 text-sm mt-1">Phone numbers do not match.</p>}
      </div>
    </div>
  );
}
